// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__8u2Xr","validationTips":"StatementDescriptor_validationTips__36y35"};